module.exports = __webpack_public_path__ + "img/IMG013.39954e1b.jpg";